import useSWR from "swr";
import { useSWRFetcher } from "./useSWRFetcher";
import { TaxModel } from "../models/InvoiceExtractionModels";
import { environment } from "../config/environment";

export const useTaxes = (businessTenantId?: string | null) => {
  const fetcher = useSWRFetcher();

  const { data, isLoading, error } = useSWR<TaxModel[]>(
    `${environment.apiUrl}/api/invoices/taxes`,
    (url: string) => {
      if (businessTenantId) {
        return fetcher(url, { headers: { "Business-Tenant": businessTenantId } });
      }
      return fetcher(url);
    },
    {}
  );

  return {
    taxes: data,
    isLoading,
    error,
  };
};
